import * as constants from './constants';
import { BulkUploadApi } from 'api';
import logger from 'helpers/logger';
import { uploadBulkUploadBlobStorage } from './helpers';

export const getBulkUploadStatusRequest = (assetId, startDate, endDate) => ({
	type: constants.actionTypes.GET_BULK_UPLOAD_STATUS_REQUEST,
	assetId,
	startDate,
	endDate,
});

export const getBulkUploadSasUrlRequest = (assetId, filename) => ({
	type: constants.actionTypes.GET_BULK_UPLOAD_SAS_URL_REQUEST,
	assetId,
	filename,
});

export const startBulkUploadRequest = (assetId, bulkUploadFiles, startDate, endDate) => ({
	type: constants.actionTypes.START_BULK_UPLOAD_REQUEST,
	assetId,
	bulkUploadFiles,
	startDate,
	endDate
});

export const setUploadLoadingAction = (isLoading) => ({
	type: constants.actionTypes.SET_UPLOAD_LOADING,
	isLoading,
});

export const setFileBlobNameAction = (file, blobName) => ({
	type: constants.actionTypes.SET_FILE_BLOB_NAME,
	file,
	blobName,
});

export const setFileUploadStatusAction = (file, status) => ({
	type: constants.actionTypes.SET_FILE_UPLOAD_STATUS,
	file,
	status,
});

export const setProcessAllowedAction = (allowed) => ({
	type: constants.actionTypes.SET_PROCESS_ALLOWED,
	allowed,
});

export const setBulkUploadStatusLoadingAction = (isLoading) => ({
	type: constants.actionTypes.SET_BULK_UPLOAD_STATUS_LOADING,
	isLoading,
});

export const setBulkUploadStatusAction = (statusData) => ({
	type: constants.actionTypes.SET_BULK_UPLOAD_STATUS,
	statusData,
});

export const clearBulkUploadData = () => ({
	type: constants.actionTypes.CLEAR_BULK_UPLOAD_DATA,
});

export const clearFileBoxAction = () => {
	return {
		type: constants.CLEAR_FILE_BOX,
	};
};

export const uploadFilesV2 = (assetId, files, from, to) => async (dispatch) => {
	dispatch(setUploadLoadingAction(true));
	let successfulUpload = false;

	for (const file of files.filter(f => f.uploadStatus !== constants.fileUploadStatus.SUCCESS)) {
		try {
			const sasResult = await BulkUploadApi.getBulkUploadSasUrl(assetId, file?.fileContent?.name);
			const { url } = sasResult || {};
			let blobName = '';
			let blobUrlName = null;
			if (url) {
				const urlWithoutParams = url.split('?')[0];
				blobName = urlWithoutParams.match(/bulk-upload\/(.+?\.zip)$/);
				blobUrlName = blobName ? decodeURIComponent(blobName[1]) : null;
			}
			dispatch(setFileBlobNameAction(file?.fileContent, blobUrlName));
			dispatch(setFileUploadStatusAction(file, constants.fileUploadStatus.LOADING));
			await uploadBulkUploadBlobStorage(url, file?.fileContent);
			dispatch(setFileUploadStatusAction(file, constants.fileUploadStatus.SUCCESS));
			successfulUpload = true;
		} catch (err) {
			dispatch(setFileUploadStatusAction(file, constants.fileUploadStatus.FAILED));
			logger.error(err?.message);
		}
	}

	dispatch(setUploadLoadingAction(false));
	dispatch(setProcessAllowedAction(successfulUpload));
	dispatch(setBulkUploadStatusLoadingAction(true));
	try {
		const statusResult = await dispatch(getBulkUploadStatusRequest(assetId, from, to));
		dispatch(setBulkUploadStatusAction(statusResult?.payload || statusResult || []));
	} catch (err) {
		dispatch(setBulkUploadStatusAction([]));
	}
	dispatch(setBulkUploadStatusLoadingAction(false));
};
